import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SortService {

  constructor() { }

  sortArray(array: any[], key: string, order: 'asc' | 'desc' = 'asc'): any[] {
    return array.sort((a, b) => {
      if (a[key] < b[key]) {
        return order === 'asc' ? -1 : 1;
      } else if (a[key] > b[key]) {
        return order === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
  }
}
